(function () {
  'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }

  /**
   * Toggle Nav
   * ======================================
   * - toggle class on body
   */

  var ELEMENTS = '.js-nav';
  var TOGGLE_CLASS = 'nav-is-open';
  var ToggleNav = /*#__PURE__*/function () {
    function ToggleNav() {
      var _this = this;
      _classCallCheck(this, ToggleNav);
      this.elements = document.querySelectorAll(ELEMENTS);
      if (!this.elements) {
        return false;
      }
      this.elements.forEach(function (el) {
        el.addEventListener('click', _this.toggleNav, false);
      });
    }
    _createClass(ToggleNav, [{
      key: "toggleNav",
      value: function toggleNav() {
        document.body.classList.toggle(TOGGLE_CLASS);
        document.body.classList.toggle('lock');
      }
    }]);
    return ToggleNav;
  }();
  new ToggleNav();

}());

//# sourceMappingURL=data:application/json;charset=utf8;base64,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
